export default function NuclearIcon() {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.99999 16.9372C13.7953 16.9372 16.872 13.8566 16.872 10.0565C16.872 6.25633 13.7953 3.17572 9.99999 3.17572C6.20465 3.17572 3.12793 6.25633 3.12793 10.0565C3.12793 13.8566 6.20465 16.9372 9.99999 16.9372Z"
                fill="white"
            />
            <path
                d="M10 3.705C13.4995 3.705 16.3434 6.55256 16.3434 10.0564C16.3434 13.5603 13.4995 16.4079 10 16.4079C6.50053 16.4079 3.65656 13.5603 3.65656 10.0564C3.65656 6.55256 6.50053 3.705 10 3.705ZM10 2.64642C5.912 2.64642 2.59932 5.96329 2.59932 10.0564C2.59932 14.1496 5.912 17.4665 10 17.4665C14.088 17.4665 17.4007 14.1496 17.4007 10.0564C17.4007 5.96329 14.0845 2.64642 10 2.64642Z"
                fill="#7E3C88"
            />
            <path
                d="M4.12175 10.0565C4.12175 13.3063 6.75427 15.9421 10 15.9421V10.0565H4.12175Z"
                fill="#7E3C88"
            />
            <path
                d="M10 4.17078V10.0565H15.8783C15.8783 6.80663 13.2457 4.17078 10 4.17078Z"
                fill="#7E3C88"
            />
        </svg>
    );
}
